<template>
  <router-view></router-view>
</template>

<script setup>
import {onMounted, nextTick, watch, onBeforeMount, onBeforeUnmount} from 'vue';
import { useRoute } from 'vue-router';
import {useStore} from "vuex";

const store = useStore();

onBeforeMount(() => {
  store.dispatch('initialize');
})

const route = useRoute();

const EMBED_PARENT_ORIGINS = [
  'https://makler.bankari.sk',
  'https://bankarire-makler-app-a1a57.web.app',
];

let embedResizeObserver;
let embedMutationObserver;
let embedReportFrame;

const reportEmbeddedHeight = () => {
  if (window.parent === window) return;
  window.cancelAnimationFrame(embedReportFrame);
  embedReportFrame = window.requestAnimationFrame(() => {
    const height = Math.max(
      document.documentElement.scrollHeight,
      document.body?.scrollHeight || 0,
    );
    const message = {
      type: 'urbo-content-height',
      height,
      url: window.location.href,
    };
    EMBED_PARENT_ORIGINS.forEach((origin) => window.parent.postMessage(message, origin));
  });
};

const startEmbeddedHeightReporter = () => {
  if (window.parent === window) return;
  reportEmbeddedHeight();
  embedResizeObserver = new ResizeObserver(reportEmbeddedHeight);
  embedResizeObserver.observe(document.documentElement);
  if (document.body) embedResizeObserver.observe(document.body);
  embedMutationObserver = new MutationObserver(reportEmbeddedHeight);
  embedMutationObserver.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
  });
  window.addEventListener('load', reportEmbeddedHeight, true);
};

const initWebflow = () => {
  nextTick(() => {
    if (window.Webflow) {
      try {
        // Zničíme staré sledovače scrollu
        window.Webflow.destroy();
        // Inicializujeme základ
        window.Webflow.ready();
        // Reštartujeme IX2 engine (animácie pri scrolle)
        const ix2 = window.Webflow.require('ix2');
        if (ix2) {
          ix2.init();
        }
        // Vynútime prepočítanie pozícií
        window.dispatchEvent(new Event('scroll'));
        console.log("Webflow inicializovaný pre stránku: ", route.path);
      } catch (err) {
        console.error("Webflow error:", err);
      }
    }
  });
};

// Pri prvom načítaní
onMounted(() => {
  initWebflow();
  startEmbeddedHeightReporter();
});

onBeforeUnmount(() => {
  embedResizeObserver?.disconnect();
  embedMutationObserver?.disconnect();
  window.cancelAnimationFrame(embedReportFrame);
  window.removeEventListener('load', reportEmbeddedHeight, true);
});

// SLEDOVANIE ZMENY STRÁNKY (Napr. prechod na detail inzerátu)
watch(
  () => route.path,
  () => {
    // Musíme dať Vue čas (napr. 500ms), aby vykreslilo nový HTML kód detailu
    setTimeout(() => {
      initWebflow();
      reportEmbeddedHeight();
    }, 500);
  }
);
</script>

<style lang="scss">
/* Tvoj štýl */
</style>
